import get from 'lodash/get'
import { default as deserialize, formatMeta } from 'app/utils/deserialize'
import { fetch } from 'app/utils/data'
import { buildFilters } from './utils'

export default {
  namespaced: true,

  state: {
    list: [],
    item: {
      account: { id: 0 }
    },
    pagination: {}
  },

  getters: {
    currentProfiles: (state) => state.list,
    currentProfile: (state) => state.item,
    currentPagination: (state) => state.pagination
  },

  mutations: {
    profilesFetched(state, { profiles }) {
      state.list = profiles
    },

    profileFetched(state, { profile }) {
      state.item = profile
    },

    paginationFetched(state, { pagination }) {
      state.pagination = pagination
    }
  },

  actions: {
    async fetchProfiles({ commit }, { page = 1, filters = {} }) {
      const response = await fetch({
        url: '/api/admin/profiles',
        params: {
          page,
          ...buildFilters(filters)
        }
      })

      const profiles = await deserialize(response.data)
      const pagination = formatMeta(get(response.data, 'meta', {}))

      commit('profilesFetched', { profiles })
      commit('paginationFetched', { pagination })
    },

    async fetchProfile({ commit }, profileId) {
      const response = await fetch({ url: `/api/admin/profiles/${profileId}` })
      const profile = await deserialize(response.data)

      commit('profileFetched', { profile })
    }
  }
}
